module.exports = __webpack_public_path__ + "img/rspt1.03b92da0.svg";